import { render, staticRenderFns } from "./RemarksBox.vue?vue&type=template&id=b800431c&scoped=true&"
import script from "./RemarksBox.vue?vue&type=script&lang=js&"
export * from "./RemarksBox.vue?vue&type=script&lang=js&"
import style0 from "./RemarksBox.vue?vue&type=style&index=0&id=b800431c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b800431c",
  null
  
)

export default component.exports